import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { getFrontEndSettings } from "../../api";
import { checkAndHandleAuth } from "../../services/authService";

type AuthStatus = "pending" | "authenticated" | "redirecting";

const PrivateRoute = () => {
  const [status, setStatus] = useState<AuthStatus>("pending");

  useEffect(() => {
    getFrontEndSettings().then((settings) => {
      if (
        settings.error instanceof Error &&
        settings.error.message === "Authentication Required"
      ) {
        setStatus("redirecting");
        checkAndHandleAuth();
      } else {
        setStatus("authenticated");
      }
    });
  }, []);

  if (status === "pending" || status === "redirecting") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner size={SpinnerSize.large} />
      </div>
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
